import type { TranslationKey } from "../app-settings/settings.ts";
import { workbenchRoutes } from "../routes/workbench-routes.ts";

export type PrimarySettingsSectionId = "general" | "users" | "company" | "templates" | "files";

export type TemplateSettingsPanelId = "templates" | "modules" | "prices" | "fonts" | "terms";

export type PrimarySettingsSection = {
  id: PrimarySettingsSectionId;
  href: string;
  titleKey: TranslationKey;
};

export type TemplateSettingsPanel = {
  id: TemplateSettingsPanelId;
};

export const primarySettingsSections: PrimarySettingsSection[] = [
  { id: "general", href: workbenchRoutes.settings, titleKey: "settings.general" },
  { id: "users", href: workbenchRoutes.settingsSection("users"), titleKey: "settings.users" },
  { id: "company", href: workbenchRoutes.settingsSection("company"), titleKey: "settings.company" },
  { id: "templates", href: workbenchRoutes.settingsSection("templates"), titleKey: "settings.templates" },
  { id: "files", href: workbenchRoutes.settingsSection("files"), titleKey: "settings.files" },
];

export const templateSettingsPanels: TemplateSettingsPanel[] = [
  { id: "templates" },
  { id: "modules" },
  { id: "prices" },
  { id: "fonts" },
  { id: "terms" },
];

export function isTemplateSettingsPanel(value: string | null | undefined): value is TemplateSettingsPanelId {
  return templateSettingsPanels.some((panel) => panel.id === value);
}
